<div class="negocios-list">
    <div class="negocios-list-item" *ngFor="let d of data">
        <negocio-item [data]="d"></negocio-item> 
    </div>
</div>
<loader *ngIf="loader"></loader>

